import * as React from 'react';
import styled from 'styled-components';

import { Utility } from 'src/styledComponents/Typography';

import { resultsPresentation } from '../../derivations';
import { LResult } from '../../types';
import { RacerName } from '../RacerName';
import { RowWrap } from './RowWrap';

const Wrapper = styled(RowWrap)`
  .grid-wrap {
    grid-template-columns: 80px 80px 1fr;
    gap: 8px;

    padding-left: 40px;
    padding-right: 10px;
  }
`;

const StyledUtility = styled(Utility)`
  color: ${(props) => props.theme.main.colors.clay2};
`;

type Props = {
  value: LResult;
  distanceId: number;
  checkpointId: number | null;
};

export const LeftSideSingleRow: React.FC<Props> = (props) => {
  const { value, distanceId, checkpointId } = props;

  const place = resultsPresentation.generatePlace(value, distanceId!, checkpointId);

  if (!value.racer) return null;

  return (
    <Wrapper distanceId={distanceId} checkpointId={checkpointId} value={value} height={64} place={place}>
      <Utility variant='u2' weight='bold'>
        {place}
      </Utility>
      <StyledUtility variant='u2' weight='medium'>
        {value.racer.bib_number}
      </StyledUtility>
      <RacerName value={value.racer} />
    </Wrapper>
  );
};
